import 'css-chunksrc/client/scenes/projectExpenseEdition/form/styles.scss';export default {
  "form": "_form_i1q68_1",
  "group": "_group_i1q68_5",
  "row": "_row_i1q68_9",
  "wideCell": "_wideCell_i1q68_16",
  "label": "_label_i1q68_23",
  "root": "_root_i1q68_29",
  "list": "_list_i1q68_33",
  "attachments": "_attachments_i1q68_40"
};